import { combineReducers } from "redux";
import changeLayoutReducer from "./changeLayout";

let rootReducer =combineReducers({changeLayoutReducer});
export default rootReducer